import * as React from "react";
export const JustificativasBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
